<template>
  <div>
    <div
      ref="title"
      :style="`width:100%; height:${ height ? height : '500px' };`"
    ></div>
    <div class="is-size-4">On-time Delivery: {{countLateOntime._percentOntime}} %</div>
    <div class="is-size-7">{{countLateOntime._onTime+countLateOntime._late}}</div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { optionPie } from '../../setting/ChartOptionPie'
export default {
  name: 'OverAllPieChart',
  props: ['chartData', 'title', 'height'],
  mounted () {
    this.initChart()
  },
  watch: {
    option: {
      handler (val) {
        if (val) {
          try {
            this.chart.setOption(val)
          } catch (error) {
            // console.log('error', error)
          }
        }
      }
    }
  },
  computed: {
    countLateOntime () {
      let _late = 0
      let _onTime = 0
      // console.log('chatData >>>', this.chartData)
      this.chartData.forEach((i) => {
        _late += i.late
        _onTime += i.notLate
      })
      const _percentOntime = ((_onTime / (_late + _onTime)) * 100).toPrecision(
        4
      )
      return { _late, _onTime, _percentOntime }
    },
    setChartOption () {
      const localChart = { ...optionPie }
      localChart.series = [
        {
          type: 'pie',
          radius: ['30%', '70%'],
          // label: {
          //   formatter: '{b|{b}} : {per|{d}%} \n {c|{c} times} ',
          //   rich: {
          //     c: {
          //       color: '#86D4B5',
          //       lineHeight: 22,
          //       align: 'center',
          //       fontSize: 25
          //     },
          //     d: {
          //       borderColor: '#8C8D8E',
          //       width: '100%',
          //       borderWidth: 1,
          //       height: 0
          //     },
          //     b: {
          //       color: '#4C5058',
          //       fontSize: 18,
          //       fontWeight: 'bold',
          //       lineHeight: 33
          //     },
          //     per: {
          //       color: '#fff',
          //       backgroundColor: '#4C5058',
          //       padding: [3, 4],
          //       borderRadius: 4
          //     }
          //   }
          // },
          data: [
            { value: this.countLateOntime._onTime, name: 'On-time' },
            { value: this.countLateOntime._late, name: 'Late' }
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
      return localChart
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$refs.title)
      this.chart.setOption(this.setChartOption)
    }
  }
}
</script>
